.rasa-rating {
  border-radius: 12px;
  background-color: var(--rating-background-color, #fff);
  color: var(--rating-text-color, #333);
  margin: 0 auto;
  padding: 8px;
  text-align: center;
  max-width: 400px;

  &__text {
    margin: 0 0 12px;
    font-size: 1rem;
    font-weight: 500;
    color: var(--rating-instruction-color, #333);
    text-align: left;
    width: 100%;
    display: block;
  }

  &__thank-you {
    margin: 0;
    font-size: 1rem;
    font-weight: 600;
    color: var(--rating-thank-you-color, #4CAF50);
    text-align: center;
    animation: fadeIn 0.3s ease-in-out;
  }

  &__options {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 8px;
    flex-wrap: nowrap;
  }

  &__option {
    width: 60px;
    height: 60px;
    background: var(--rating-option-background-color, #fff);
    border: 1px solid var(--rating-option-border-color, #ddd);
    border-radius: 8px;
    cursor: pointer;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    transition: transform 0.2s ease, background-color 0.3s, box-shadow 0.3s;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
    flex: none;

    &:hover {
      background: var(--rating-option-hover-color, #f9f9f9);
      transform: scale(1.05);
      box-shadow: 0 3px 6px rgba(0, 0, 0, 0.15);
    }

    &--selected {
      border-color: var(--rating-option-selected-border-color, #007bff);
      background: var(--rating-option-selected-background-color, #e9f5ff);
      color: var(--rating-option-selected-text-color, #007bff);
      box-shadow: 0 4px 8px rgba(0, 123, 255, 0.2);
    }
  }

  &__icon {
    width: 40px;
    height: 40px;
    display: flex;
    justify-content: center;
    align-items: center;

    svg {
      width: 100%;
      height: 100%;
      display: block;
    }
  }

  &__label {
    font-size: 0.875rem;
    font-weight: 500;
    color: var(--rating-option-label-color, #444);
    text-align: center;
    display: block;
  }
}

@media (max-width: 768px) {
  .rasa-rating__options {
    gap: 6px;
  }

  .rasa-rating__option {
    width: 50px;
    height: 50px;
    padding: 6px;
  }

  .rasa-rating__thank-you {
    font-size: 1rem;
  }
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
